import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ced1e864"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-view"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "el-dropdown-link"
}, " 选项 ", -1));
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  key: 0,
  class: "h_left"
};
const _hoisted_5 = {
  class: "h_left_t"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "互联网大数据 ", -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "健康大数据", -1));
const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "常见病大数据", -1));
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "中医体质大数据", -1));
const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = {
  key: 1,
  class: "h_right"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "感冒气象指数", -1));
const _hoisted_16 = [_hoisted_15];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "健康全息档案", -1));
const _hoisted_18 = [_hoisted_17];
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "问诊实时动态", -1));
const _hoisted_20 = [_hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h_centre"
}, [/*#__PURE__*/_createElementVNode("p", null, "方舟控股 方舟京医互联网医院")], -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-jia"
}, null, -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回首页", -1));
const _hoisted_24 = [_hoisted_22, _hoisted_23];
const _hoisted_25 = {
  class: "main"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dropdown, {
    "hide-on-click": false,
    class: "logout"
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
      onClick: _ctx.ElDropdown
    }, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        "data-index": "2"
      }, {
        default: _withCtx(() => [_createTextVNode("退出")]),
        _: 1
      })]),
      _: 1
    }, 8, ["onClick"])]),
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [_ctx.issearch !== true ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("ul", _hoisted_5, [_createElementVNode("li", {
    class: _normalizeClass({
      active: $setup.hactive == 'internet'
    }),
    onClick: _cache[0] || (_cache[0] = $event => $setup.bindheader('internet'))
  }, _hoisted_7, 2), _createElementVNode("li", {
    class: _normalizeClass([{
      active: $setup.hactive == 'health'
    }]),
    onClick: _cache[1] || (_cache[1] = $event => $setup.bindheader('health'))
  }, _hoisted_9, 2), _createElementVNode("li", {
    class: _normalizeClass([{
      active: $setup.hactive == 'commondis'
    }, {
      active: $setup.hactive == 'commondis2'
    }]),
    onClick: _cache[2] || (_cache[2] = $event => $setup.bindheader('commondis'))
  }, _hoisted_11, 2), _createElementVNode("li", {
    class: _normalizeClass([{
      active: $setup.hactive == 'tcmconst'
    }]),
    onClick: _cache[3] || (_cache[3] = $event => $setup.bindheader('tcmconst'))
  }, _hoisted_13, 2)])])) : _createCommentVNode("", true), _ctx.issearch !== true ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("ul", null, [_createElementVNode("li", {
    class: _normalizeClass([{
      active: $setup.hactive == 'weathercold'
    }]),
    onClick: _cache[4] || (_cache[4] = $event => $setup.bindheader('weathercold'))
  }, _hoisted_16, 2), _createElementVNode("li", {
    class: _normalizeClass([{
      active: $setup.hactive == 'holohealth'
    }, {
      active: $setup.hactive == 'holohealth2'
    }]),
    onClick: _cache[5] || (_cache[5] = $event => $setup.bindheader('holohealth'))
  }, _hoisted_18, 2), _createElementVNode("li", {
    class: _normalizeClass([{
      active: $setup.hactive == 'intreatment'
    }]),
    onClick: _cache[6] || (_cache[6] = $event => $setup.bindheader('intreatment'))
  }, _hoisted_20, 2), _createElementVNode("li", null, [_createElementVNode("span", null, _toDisplayString(_ctx.year) + "年 ", 1)])])])) : _createCommentVNode("", true), _hoisted_21, _ctx.issearch ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "homepage",
    onClick: _cache[7] || (_cache[7] = (...args) => _ctx.goRealTime && _ctx.goRealTime(...args))
  }, _hoisted_24)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_router_view)])]);
}